import React, { Component } from 'react';
import  createHistory  from 'history/createBrowserHistory';
import Help_hints from "../../wepcg/sidebar/help_hints";
import "../../wepcg/sidebar/css/wepcg_bar.css"

class ProductDamageBar extends Component{
    constructor(props) {
        super(props);
        this.history = createHistory();
    }
    render() {
        return <div className="bar">
            <h1><strong>Product Damage</strong></h1>
            <p>
                This claim type is used for physical damage to the actual item in intact packaging; damage probably occurred in manufacturing. Please upload photos of the damage. We ask you to submit the claim as soon as possible, latest in 5 business days after the delivery (POD date). Please contact our financial claims team in case there is any question or problem.
            </p>
            <Help_hints />
        </div>
    }
}

export default ProductDamageBar;